<ng-container *ngIf="options && mainForm !== undefined">
  <div class="checkboxBlock-group" [formGroup]="mainForm">
    <div *ngFor="let o of options; let i=index;" class="checkboxBlock-item">
      <input type="checkbox" [checked]="o.isChecked" [formControlName]="controlName" [value]="o"
        [id]="controlName + idSuffix + '_' + i" class="checkboxBlock-input">
      <label [for]="controlName + idSuffix + '_' + i" class="checkboxBlock-label {{layoutModifier}}">
        <span svgIcon [icon]="'checkbox-check'"></span>
        <ng-container *ngIf="labelKey && o[labelKey]">
          {{ o[labelKey] | translate }}
        </ng-container>
      </label>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="options && mainForm === undefined">
  <div *ngFor="let o of options; let i=index;" class="checkboxBlock-item checkboxBlock-item_single">
    <input [id]="controlName + '_' + i" type="checkbox" [disabled]="o.isDisabled" [checked]="o.isChecked" [indeterminate]="o.isIndeterminate" class="checkboxBlock-input" />
    <label [for]="controlName + '_' + i"  class="checkboxBlock-label {{layoutModifier}}">
      <span svgIcon [icon]="'checkbox'"></span>
    </label>
  </div>
</ng-container>
